import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueApollo from 'vue-apollo'
// import apolloClient from '@/utils/apollo'
import { sync } from 'vuex-router-sync'

import i18n from '@/i18n'

import multiSelect from 'vue-multiselect'

import VueSwal from 'vue-swal'

import VeeValidate from 'vee-validate'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesZhTW from 'vee-validate/dist/locale/zh_TW'

import 'vue-multiselect/dist/vue-multiselect.min.css'

import 'owlsight/dist/main.css'
import 'owlsight/icons/css/owl.css'
import 'owlsight/icons/css/animation.css'

import clickOutside from '@/directives/clickOutside'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Flicking from '@egjs/vue-flicking'
// import '@egjs/vue-flicking/dist/flicking.css'

// App Stylesheets
import '@/stylesheets/main.sass'

Vue.config.productionTip = false
// Vue.use(VueApollo)

Vue.filter('imageUrl', function (path = '') {
  return process.env.VUE_APP_IMAGE_ROOT + path
})

Vue.filter('i18n', function (meta, key = '') {
  if (meta && meta[store.getters.lang]) {
    return meta[store.getters.lang]
  } else if (meta && meta['zh-TW']) {
    return meta['zh-TW']
  }
  return key
})

Vue.component('multiSelect', multiSelect)

Vue.directive('clickOutside', clickOutside)

Vue.prototype.$filters = Vue.options.filters

sync(store, router)
Vue.use(Flicking)
Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  errorBagName: 'errorBags',
  fieldsBagName: 'fieldBags',
  dictionary: {
    en: validationMessagesEn,
    'zh-TW': validationMessagesZhTW
  }
})

i18n.locale = store.getters.lang
VeeValidate.Validator.localize(store.getters.lang)

Vue.use(VueSwal)

Vue.use(ElementUI)

// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient
// })

new Vue({
  i18n,
  router,
  store,
  // apolloProvider,
  render: h => h(App)
}).$mount('#app')
